import { MapTo } from '@adobe/aem-react-editable-components';
import TermsSlider, { TermsSliderEditConfig } from './TermsSlider';

export default MapTo('cob-corp-acquisition/components/creditonebank/terms-slider')(TermsSlider, TermsSliderEditConfig);